import { API } from './apiClient'
import { Email, Verify, OnetimeKey, InquiryCode } from '../models/verifyModel'

export const postVerifyCode = (data: Email): Promise<void> => {
  return API.post('/send-verify-code', data)
}

export const putVerifyCode = (data: Verify): Promise<OnetimeKey> => {
  return API.put('/verify', data)
}

export const putInquiryCode = (data: InquiryCode): Promise<OnetimeKey> => {
  return API.put('/verify/inquiry-code', data)
}
